import { renderRoutes } from 'react-router-config';
import { getRoutes, RFC } from 'configs/navigation';

const Goals: RFC = ({ route }) => {
  return renderRoutes(getRoutes(route));
};

export default Goals;
